import React from 'react'

import {HolidayPiratesHeader} from './HolidayPiratesHeader'

export {CUSTOM_HEADER_HEIGHT} from './constants'

interface Props {
  /** The brand code to determine which header to render */
  brandCode: string
  /** Whether to float the header above the content. Default is `true` */
  isFloating?: boolean
  /** Whether to fix the header to the top of the page. Default is `true` */
  isFixed?: boolean
}

/**
 * Renders a custom header based on the brand code.
 */
export const CustomHeader = ({
  brandCode,
  isFloating = false,
  isFixed = true
}: Props) => {
  if (brandCode === 'holidaypiratesde') {
    return <HolidayPiratesHeader isFloating={isFloating} isFixed={isFixed} />
  }

  return null
}
